import * as fns from 'date-fns'
import {
  DUE_DATE_MONTH_RANGE,
  MAXIMUM_PATIENT_AGE,
  MINIMUM_PATIENT_AGE,
} from 'shared/constants'

export const isDueDateWithinRange = (dueDate: string) => {
  const now = new Date()
  const sixMonthsInTheFuture = fns.startOfDay(
    fns.add(now, { months: DUE_DATE_MONTH_RANGE })
  )
  const sixMonthsInThePast = fns.startOfDay(
    fns.sub(now, { months: DUE_DATE_MONTH_RANGE })
  )
  const parsedDueDate = fns.parseISO(dueDate)
  return fns.isWithinInterval(parsedDueDate, {
    start: sixMonthsInThePast,
    end: sixMonthsInTheFuture,
  })
}

export const isBirthdayWithinRange = (birthday: string) => {
  const now = new Date()
  const sixteenYearsInThePast = fns.startOfDay(
    fns.sub(now, { years: MINIMUM_PATIENT_AGE })
  )
  const sixtyYearsInThePast = fns.startOfDay(
    fns.sub(now, { years: MAXIMUM_PATIENT_AGE })
  )
  const parsedBirthday = fns.parseISO(birthday)
  return fns.isWithinInterval(parsedBirthday, {
    start: sixtyYearsInThePast,
    end: sixteenYearsInThePast,
  })
}
